import { useCurrentRole } from './useCurrentRole';

export const useCurrentResource = () => {
  const currentRole = useCurrentRole();

  return currentRole?.resource;
};
